import { forwardRef } from "react";
import { votdImageUrl } from "../api";

// The shareable verse art: cinematic background + accurate scripture overlaid.
export const VerseArt = forwardRef(function VerseArt({ votd, className = "" }, ref) {
  return (
    <div ref={ref} data-testid="verse-art" className={`relative overflow-hidden bg-neutral-900 ${className}`}>
      {votd.has_image && (
        <img
          src={votdImageUrl(votd.slug)}
          alt=""
          crossOrigin="anonymous"
          className="absolute inset-0 h-full w-full object-cover"
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/75" />
      <div className="relative flex h-full flex-col items-center justify-center px-7 py-10 text-center text-white">
        {votd.occasion && (
          <span className="font-ui mb-5 rounded-full bg-white/15 px-3 py-1 text-[0.65rem] font-semibold uppercase tracking-[0.22em] backdrop-blur">
            {votd.occasion}
          </span>
        )}
        <p className="font-serif-display text-2xl leading-relaxed drop-shadow-[0_2px_12px_rgba(0,0,0,0.6)] md:text-3xl">
          “{votd.verse_text}”
        </p>
        <div className="mt-6 h-px w-12 bg-white/50" />
        <p className="font-ui mt-4 text-sm font-semibold uppercase tracking-[0.3em] drop-shadow">
          {votd.verse_ref}{votd.translation ? ` · ${votd.translation}` : ""}
        </p>
        {votd.copyright && (
          <p className="font-ui mt-3 max-w-[88%] text-[0.55rem] leading-tight text-white/55">{votd.copyright}</p>
        )}
        <p className="font-ui mt-4 text-[0.6rem] uppercase tracking-[0.3em] text-white/60">Clarity Bible</p>
      </div>
    </div>
  );
});
